/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to start mass email campaign
 * @export
 * @interface MassEmailCampaignRequest
 */
export interface MassEmailCampaignRequest {
    /**
     * List of recipient email addresses
     * @type {Array<string>}
     * @memberof MassEmailCampaignRequest
     */
    recipientList: Array<string>;
    /**
     * Email subject (required if templateId not provided)
     * @type {string}
     * @memberof MassEmailCampaignRequest
     */
    subject?: string;
    /**
     * HTML body (optional; ignored if templateId provided)
     * @type {string}
     * @memberof MassEmailCampaignRequest
     */
    bodyHtml?: string;
    /**
     * Plain text body (ignored if templateId provided)
     * @type {string}
     * @memberof MassEmailCampaignRequest
     */
    bodyPlain?: string;
    /**
     * Template ID from EMAIL_TEMPLATES config. If provided, subject/body resolved from template with variable substitution.
     * @type {string}
     * @memberof MassEmailCampaignRequest
     */
    templateId?: string;
    /**
     * Variables for template substitution when templateId is used
     * @type {{ [key: string]: any; }}
     * @memberof MassEmailCampaignRequest
     */
    variables?: { [key: string]: any; };
    /**
     * Emails per batch (default 100)
     * @type {number}
     * @memberof MassEmailCampaignRequest
     */
    batchSize?: number;
    /**
     * Max emails per minute for rate limiting (default 60)
     * @type {number}
     * @memberof MassEmailCampaignRequest
     */
    rateLimitPerMinute?: number;
    /**
     * Tenant ID (optional; uses session tenant if not provided)
     * @type {string}
     * @memberof MassEmailCampaignRequest
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the MassEmailCampaignRequest interface.
 */
export function instanceOfMassEmailCampaignRequest(value: object): value is MassEmailCampaignRequest {
    if (!('recipientList' in value) || value['recipientList'] === undefined) return false;
    return true;
}

export function MassEmailCampaignRequestFromJSON(json: any): MassEmailCampaignRequest {
    return MassEmailCampaignRequestFromJSONTyped(json, false);
}

export function MassEmailCampaignRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MassEmailCampaignRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientList': json['recipientList'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'bodyHtml': json['bodyHtml'] == null ? undefined : json['bodyHtml'],
        'bodyPlain': json['bodyPlain'] == null ? undefined : json['bodyPlain'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'variables': json['variables'] == null ? undefined : json['variables'],
        'batchSize': json['batchSize'] == null ? undefined : json['batchSize'],
        'rateLimitPerMinute': json['rateLimitPerMinute'] == null ? undefined : json['rateLimitPerMinute'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function MassEmailCampaignRequestToJSON(json: any): MassEmailCampaignRequest {
    return MassEmailCampaignRequestToJSONTyped(json, false);
}

export function MassEmailCampaignRequestToJSONTyped(value?: MassEmailCampaignRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipientList': value['recipientList'],
        'subject': value['subject'],
        'bodyHtml': value['bodyHtml'],
        'bodyPlain': value['bodyPlain'],
        'templateId': value['templateId'],
        'variables': value['variables'],
        'batchSize': value['batchSize'],
        'rateLimitPerMinute': value['rateLimitPerMinute'],
        'tenantId': value['tenantId'],
    };
}

